export const DAO_CODE = 'ATTACHMENT' + '_DAO';
